import { useUserFormRole } from './useUserFormRole';

// For a form at the submission/initiation stage
export const useIsRequiredElement = (element, form_has_only_one_submitter = false) => {
  const userFormRole = useUserFormRole();
  return form_has_only_one_submitter ? !!element.options.requiredFor : element.options.requiredFor === userFormRole;
};
